import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { SubscriptionStatus } from "../types";
export function useSubscriptionStatus() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      queryKey: QUERY_KEYS.SUBSCRIPTION_STATUS,
      queryFn: () => apiFetcher("/api/v1/payment/watch"),
      staleTime: 300000,
      gcTime: 600000,
      refetchInterval: 300000
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}